import { Autocomplete, InputAdornment, TextField } from "@mui/material";
import TrendsBDKwMtfilterObjs from "./TrendsBDKwMtfilterObjs";
import { Stack } from "@mui/system";
import SearchIcon from "@mui/icons-material/Search";
import { useSelector } from "react-redux";
import { setSelectedKeyword } from "../../../../../../../features/trendsSlice";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
const TrendsBDKwMtfilterCard = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const { keywordMatchTypeDataTrendsBreakdown, selectedKeyword } = useSelector(
    (state: any) => state.trends
  );
  const options =
    keywordMatchTypeDataTrendsBreakdown?.data?.data?.query_output?.map(
      (item: any) => item.keyword_name
    ) || [];
  const uniqueOptions = Array.isArray(options)
    ? Array.from(new Set(options)).filter(Boolean)
    : [];

  const handleChange: any = (_: any, newValue: string | null) => {
    dispatch(setSelectedKeyword(newValue));
    if (newValue) {
      searchParams.set("keywordSearch", newValue);
    } else {
      searchParams.delete("keywordSearch");
    }
    setSearchParams(searchParams);
  };

  useEffect(() => {
    // Update selectedKeyword when searchParams change (e.g., on back/forward navigation)
    const keywordSearch = searchParams.get("keywordSearch") || "";
    dispatch(setSelectedKeyword(keywordSearch));
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Stack
        flexDirection={"row"}
        justifyContent={"start"}
        gap={4}
        sx={{ paddingBlock: "16px" }}
      >
        <Autocomplete
          sx={{ width: "500px" }}
          options={uniqueOptions}
          onChange={handleChange}
          value={
            uniqueOptions.includes(selectedKeyword) ? selectedKeyword : null
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="Keyword"
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ marginLeft: "10px" }} />
                  </InputAdornment>
                ),
              }}
              color="secondary"
            />
          )}
          size="small"
        />
        <Stack
          flexDirection={"row"}
          justifyContent={"space-between"}
          sx={{ width: "100%" }}
        >
          <TrendsBDKwMtfilterObjs />
        </Stack>
      </Stack>
    </>
  );
};

export default TrendsBDKwMtfilterCard;
